import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { Brightness4, Brightness7 } from '@mui/icons-material';
import { useTheme } from '../../themes/ThemeProvider';
import { observer } from 'mobx-react';

const ThemeToggleButton = observer(({ variant = 'default' }) => {
    const { toggleTheme, isDarkTheme } = useTheme();

    const handleToggle = () => {
        toggleTheme();
    };

    const getStyles = () => {
        if (variant === 'login') {
            return {
                position: 'absolute',
                top: 16,
                right: 16,
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.2)',
                },
                transition: 'all 0.2s',
            };
        }
        // Default variant for AppBar
        return {
            transition: 'transform 0.2s',
            '&:hover': {
                transform: 'rotate(180deg)'
            }
        };
    };

    return (
        <Tooltip title={`Cambiar a tema ${isDarkTheme() ? 'claro' : 'oscuro'}`}>
            <IconButton
                onClick={handleToggle}
                color="inherit"
                size="large"
                sx={getStyles()}
            >
                {isDarkTheme() ? <Brightness7 /> : <Brightness4 />}
            </IconButton>
        </Tooltip>
    );
});

export default ThemeToggleButton;